// extracted by mini-css-extract-plugin
module.exports = {"main":"CompanyInfoForm-module_main_56995","title":"CompanyInfoForm-module_title_c9739","body":"CompanyInfoForm-module_body_43d53","row":"CompanyInfoForm-module_row_bdeca"};